(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('pingTreeTargetService', pingTreeTargetService);

  function pingTreeTargetService(
    _,
    $http,
    concurrencyMatrixService,
    ngAuthSettings,
    promiseCacheService,
    utils,
    statsService
  ) {
    'ngInject';

    const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

    const columnSettings = {
      name: {
        class: 'tablesort-sortable',
        stSort: 'name',
        displayName: 'TARGETS_NAME'
      },
      callType: {
        class: 'tablesort-sortable width-60',
        stSort: 'instructions.callType',
        displayName: 'TARGETS_TYPE'
      },
      destination: {
        class: 'tablesort-sortable',
        stSort: 'instructions.number',
        displayName: 'TARGETS_DESTINATION'
      },
      currentLive: {
        class: 'tablesort-sortable text-left p-l-15',
        stSort: 'usageStats.currentLive',
        displayName: 'STATS_LIVE',
        rowAlign: 'left'
      },
      currentHour: {
        class: 'tablesort-sortable text-left p-l-15',
        stSort: 'usageStats.currentHour',
        displayName: 'STATS_HOUR',
        rowAlign: 'left'
      },
      currentDay: {
        class: 'tablesort-sortable text-left p-l-15',
        stSort: 'usageStats.currentDay',
        displayName: 'STATS_DAY',
        rowAlign: 'left'
      },
      currentMonth: {
        class: 'tablesort-sortable text-left p-l-15',
        stSort: 'usageStats.currentMonth',
        displayName: 'STATS_MONTH',
        rowAlign: 'left'
      },
      total: {
        class: 'tablesort-sortable text-left p-l-15',
        stSort: 'usageStats.total',
        displayName: 'STATS_TOTAL',
        rowAlign: 'left'
      },
      status: {
        class: 'tablesort-sortable',
        stSort: 'tStatus.uiStatus.status',
        displayName: 'STATUS_TEXT',
        rowAlign: 'center'
      },
      owner: {
        class: 'tablesort-sortable',
        stSort: 'owner.name',
        displayName: 'TARGETS_OWNER',
        rowAlign: 'left',
        hideForUserType: ['buyer']
      },
      enabled: {
        class: 'tablesort-sortable',
        stSort: 'enabled',
        displayName: 'ENABLED_TEXT'
      }
    };

    const defaultColumns = [
      'name',
      'owner',
      'callType',
      'destination',
      'currentLive',
      'currentHour',
      'currentDay',
      'currentMonth',
      'total',
      'status'
    ];

    const callTypes = [{
      id: 'number',
      name: 'Number'
    }, {
      id: 'sip',
      name: 'SIP'
    }];

    const targetCapTypes = [{
      name: 'Conversion',
      value: 'onConvert'
    }, {
      name: 'Connection',
      value: 'onConnect'
    }];

    const blockReasonTranslation = {
      'OPEN': {
        className: 'green_status',
        tooltip: 'TARGETS_STATUS_OPEN',
        status: 'open',
      },
      'CLOSED': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_DISABLED',
        status: 'red-disabled',
      },
      'ConcurrencyHit': {
        className: 'yellow_status',
        tooltip: 'TARGETS_STATUS_CC_HIT',
        status: 'capped',
      },
      'GroupConcurrencyHit': {
        className: 'yellow_status',
        tooltip: 'TARGETS_STATUS_CC_HIT_GROUP',
        status: 'capped',
      },
      'IsCapped': {
        className: 'yellow_status',
        tooltip: 'TARGETS_STATUS_CAPPED',
        status: 'capped',
      },
      'GroupIsCapped': {
        className: 'yellow_status',
        tooltip: 'TARGETS_STATUS_CAPPED_GROUP',
        status: 'capped',
      },
      'IsClosed': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_CLOSED',
        status: 'red-disabled',
      },
      'RingTreeIsClosed': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_CLOSED',
        status: 'red-disabled',
      },
      'GroupIsClosed': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_CLOSED_GROUP',
        status: 'red-disabled',
      },
      'Disabled': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_DISABLED',
        status: 'red-disabled',
      },
      'GroupDisabled': {
        className: 'red_status',
        tooltip: 'TARGETS_STATUS_DISABLED_GROUP',
        status: 'red-disabled',
      },
      'BuyerConcurrencyHit': {
        className: 'yellow_status',
        tooltip: 'BUYERS_STATUS_CC_HIT',
        status: 'capped',
      },
      'BuyerIsCapped': {
        className: 'yellow_status',
        tooltip: 'BUYERS_STATUS_CAPPED',
        status: 'capped',
      },
    };

    const service = {
      initNewTarget: initNewTarget,
      initBidAcceptanceSettings: initBidAcceptanceSettings,
      callTypes: callTypes,
      getTargets: getTargets,
      getCachedTargets: getCachedTargets,
      getTarget: getTarget,
      createTarget: createTarget,
      checkIfDuplicate: checkIfDuplicate,
      updateTarget: updateTarget,
      updateTargetProperty: updateTargetProperty,
      updateParseSettings: updateParseSettings,
      getTargetReferences: getTargetReferences,
      deleteTarget: deleteTarget,
      columnSettings: columnSettings,
      defaultColumns: defaultColumns,
      resetCallCounters: resetCallCounters,
      buyerToggleTargetEnabled: buyerToggleTargetEnabled,
      buyerSetConcurrencyCap: buyerSetConcurrencyCap,
      targetCapTypes: targetCapTypes,
      addBuyer: addBuyer,
      removeBuyer: removeBuyer,
      duplicateTarget: duplicateTarget,
      formatParsers: formatParsers,
      linkToItem: linkToItem,
      unLinkItem: unLinkItem,
      blockReasonTranslation: blockReasonTranslation,
      buildRTTConfig: buildRTTConfig,
    };

    return service;

    function initNewTarget() {
      return {
        instructions: {
          callType: 'number'
        },
        isBasic: true,
        targetCallIncrement: 'onConvert',
        contentType: 'application/json',
        dynamicBidAmountParser: [],
        shouldAcceptCallParser: [],
        dynamicCallLengthSettingParser: [],
        dynamicDialSettingParser: [],
        bidIDParseSettingsParser: [],
        dynamicDialSettingParserSecondStep: [],
        headers: {},
        bidAcceptanceSettings: initBidAcceptanceSettings(),
        isCriteriaInverted: false,
      };
    }


    function initBidAcceptanceSettings() {
      return {
        enabled: false,
        required: false,
        bidIDRequired: false,
        numberRequired: false,
        headers: {},
        bidIDParseSettings: [],
        body: '',
        contentType: 'application/json',
        parseSettings: {
          dynamicDial: []
        },
        method: 'post',
        pingTimeoutInMS: 5000,
      };
    }

    function getCachedTargets(accountId) {
      const url = serviceBaseUri + accountId + '/pingtreetargets';
      return promiseCacheService.getCallWithCachedPromise(_getCachedKey(accountId), url, 30);
    }

    function getTargets(accountId, getStats, updateStatsObj) {
      const url = serviceBaseUri + accountId + '/pingtreetargets';
      let params = {};
      if (getStats) {
        params = {
          includeStats: true
        };
      }
      return $http({
        url: url,
        method: 'GET',
        params: params
      }).then(function (response) {
        let targets;
        if (updateStatsObj) {
          targets = updateStatsObj.targets;
        } else {
          targets = response.data.pingTreeTargets;
        }

        if (getStats) {
          statsService.normalizeStats(targets, response.data.stats, response.data.caps, blockReasonTranslation);
        }
        return targets;
      });
    }

    function getTarget(accountId, targetId) {
      const url = _serviceBaseUrl(accountId, targetId);
      return $http.get(url);
    }

    function createTarget(accountId, target) {
      const url = serviceBaseUri + accountId + '/pingtreetargets';
      _setDefaults(target);
      _updateSecondStepSettings(target);
      if (target.schedule.callConcurrencyMatrix) {
        target.schedule.callConcurrencyMatrix = concurrencyMatrixService.postProcessMatrix(target.schedule.callConcurrencyMatrix);
      }
      if (target.schedule.callCapMatrix) {
        target.schedule.callCapMatrix = concurrencyMatrixService.postProcessMatrix(target.schedule.callCapMatrix);
      }
      return $http.post(url, target);
    }

    function checkIfDuplicate(accountId, target) {
      const url = serviceBaseUri + accountId + '/pingtreetargets/isDuplicate';
      return $http.post(url, target);
    }

    function updateTarget(accountId, target) {
      const sanitizedTarget = _sanitizePingTreeTarget(target);
      const url = _serviceBaseUrl(accountId, sanitizedTarget.id);
      _setDefaults(sanitizedTarget);
      _updateSecondStepSettings(sanitizedTarget); 
      const updatedTarget = _removeUnPatchableItems(sanitizedTarget);
      if (updatedTarget.schedule.callConcurrencyMatrix) {
        updatedTarget.schedule.callConcurrencyMatrix = concurrencyMatrixService.postProcessMatrix(updatedTarget.schedule.callConcurrencyMatrix);
      }
      if (updatedTarget.schedule.callCapMatrix) {
        updatedTarget.schedule.callCapMatrix = concurrencyMatrixService.postProcessMatrix(updatedTarget.schedule.callCapMatrix);
      }
      return $http.patch(url, updatedTarget);
    }

    function updateParseSettings(accountId, target) {
      const url = _serviceBaseUrl(accountId, target.id) + '/ParseSetting';

      const parseSettings = {
        dynamicBidAmountParser: target.dynamicBidAmountParser,
        shouldAcceptCallParser: target.shouldAcceptCallParser,
        dynamicCallLengthSettingParser: target.dynamicCallLengthSettingParser,
        dynamicDialSettingParser: target.dynamicDialSettingParser
      };

      return $http.put(url, parseSettings);
    }

    function formatParsers(pingTreeTarget) {
      const parseSettings = pingTreeTarget.parseSettings || {};
      const bidAcceptanceSettings = pingTreeTarget.bidAcceptanceSettings || {};
      if (bidAcceptanceSettings.method) {
        bidAcceptanceSettings.method = bidAcceptanceSettings.method.toLowerCase();
      }
      const parseSettingsSecondStep = bidAcceptanceSettings.parseSettings || {};

      pingTreeTarget.dynamicBidAmountParser = (parseSettings.bidAmount || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      pingTreeTarget.shouldAcceptCallParser = (parseSettings.acceptCall || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      pingTreeTarget.dynamicDialSettingParser = (parseSettings.dynamicDial || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      pingTreeTarget.dynamicCallLengthSettingParser = (parseSettings.dynamicCallLength || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      pingTreeTarget.bidIDParseSettingsParser = (bidAcceptanceSettings.bidIDParseSettings || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      pingTreeTarget.dynamicDialSettingParserSecondStep = (parseSettingsSecondStep.dynamicDial || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      if (pingTreeTarget.schedule.callConcurrencyMatrix) {
        pingTreeTarget.schedule.callConcurrencyMatrix = concurrencyMatrixService.getProcessMatrix(pingTreeTarget.schedule.callConcurrencyMatrix);
      }
      if (pingTreeTarget.schedule.callCapMatrix) {
        pingTreeTarget.schedule.callCapMatrix = concurrencyMatrixService.getProcessMatrix(pingTreeTarget.schedule.callCapMatrix);
      }

      return pingTreeTarget;
    }

    function _updateSecondStepSettings(target) {
      if (target.bidAcceptanceSettings) {
        target.bidAcceptanceSettings.method.toUpperCase();
        target.bidAcceptanceSettings.bidIDParseSettings = (target.bidIDParseSettingsParser || []).map(function (element) {
          return { type: element.parserType.toLowerCase(), value: element.Value };
        });
        target.bidAcceptanceSettings.parseSettings = target.bidAcceptanceSettings.parseSettings || {};
        target.bidAcceptanceSettings.parseSettings.dynamicDial = (target.dynamicDialSettingParserSecondStep || []).map(function (element) {
          return { type: element.parserType.toLowerCase(), value: element.Value };
        });
      }
      delete target.bidIDParseSettingsParser;
      delete target.dynamicDialSettingParserSecondStep;
      return target;
    }

    function deleteTarget(accountId, targetId, force) {
      const url = _serviceBaseUrl(accountId, targetId) + '?force=' + force;
      return $http.delete(url);
    }

    function getTargetReferences(accountId, targetId) {
      const url = _serviceBaseUrl(accountId, targetId) + '/InboundReferences';
      return $http.get(url);
    }

    function updateTargetProperty(accountId, targetId, item) {
      const url = _serviceBaseUrl(accountId, targetId);
      const updatedItem = _removeUnPatchableItems(item);
      if (updatedItem.schedule && updatedItem.schedule.callConcurrencyMatrix) {
        updatedItem.schedule.callConcurrencyMatrix = concurrencyMatrixService.postProcessMatrix(updatedItem.schedule.callConcurrencyMatrix);
      }
      if (updatedItem.schedule && updatedItem.schedule.callCapMatrix) {
        updatedItem.schedule.callCapMatrix = concurrencyMatrixService.postProcessMatrix(updatedItem.schedule.callCapMatrix);
      }
      return $http.patch(url, updatedItem);
    }

    function addBuyer(accountId, targetId, buyerId) {
      const url = _serviceBaseUrl(accountId, targetId) + '/Buyer';

      return $http.put(url, { buyerId: buyerId });
    }

    function removeBuyer(accountId, targetId, buyerId) {
      const url = _serviceBaseUrl(accountId, targetId) + '/Buyer/' + buyerId;

      return $http.delete(url);
    }

    function buildRTTConfig(accountId, item) {
      const url = _serviceBaseUrl(accountId, '') + 'BuildRTTConfiguration';
      
      return $http.post(url, item);
    }

    function linkToItem(accountId, targetId, item) {
      const url = _serviceBaseUrl(accountId, targetId) + '/Link';

      return $http.patch(url, item);
    }

    function unLinkItem(accountId, targetId, unlinkRequest) {
      const url = _serviceBaseUrl(accountId, targetId) + '/UnLink';

      return $http.patch(url, unlinkRequest);
    }

    function resetCallCounters(accountId, targetId) {
      const url = _serviceBaseUrl(accountId, targetId) + '/resetcount';
      return $http.delete(url);
    }

    function buyerToggleTargetEnabled(accountId, targetId) {
      const url = _serviceBaseUrl(accountId, targetId) + '/buyertogglepause';
      return $http.put(url);
    }

    function buyerSetConcurrencyCap(accountId, targetId, data) {
      const url = _serviceBaseUrl(accountId, targetId) + '/buyersetcaps';
      if (data.callConcurrencyMatrix) {
        data.callConcurrencyMatrix = concurrencyMatrixService.postProcessMatrix(data.callConcurrencyMatrix);
      }
      if (data.callCapMatrix) {
        data.callCapMatrix = concurrencyMatrixService.postProcessMatrix(data.callCapMatrix);
      }
      return $http.put(url, data);
    }

    function duplicateTarget(accountId, targetId) {
      return getTarget(accountId, targetId).then(function (response) {
        if (response && response.data && response.data.pingTreeTarget) {
          const target = response.data.pingTreeTarget;

          target.id = null;
          target.pingTreeId = null;

          target.name += ' - Copy';

          // Set a flag on the RTT for use in the controller
          target.isDuplicate = true;

          return { target: target, isRtbRTTResponse: response.data.isRtbRTTResponse };
        }

        return null;
      });
    }

    function _removeUnPatchableItems(target) {
      //owner can not be patched
      const newTarget = angular.copy(target);
      if (typeof newTarget.owner !== 'undefined') {
        delete newTarget.owner;
      }

      delete newTarget.dynamicBidAmountParser;
      delete newTarget.shouldAcceptCallParser;
      delete newTarget.dynamicDialSettingParser;
      delete newTarget.dynamicCallLengthSettingParser;

      return newTarget;
    }

    function _sanitizePingTreeTarget(target) {
      const sanitizedTarget = angular.copy(target);

      delete sanitizedTarget.showEditForm;
      
      sanitizedTarget.usageStats = undefined;
      sanitizedTarget.tStatus = undefined;
      sanitizedTarget.caps = undefined;

      return sanitizedTarget;
    }

    function _setDefaults(target) {
      target.conversionTimerOffset = target.conversionTimerOffset || 0;
      target.instructions = target.instructions || {};
      target.instructions.connectionTimeOut = target.instructions.connectionTimeOut || 0;
    }

    function _serviceBaseUrl(accountId, targetId) {
      return serviceBaseUri + accountId + '/pingtreetargets/' + targetId;
    }

    function _getCachedKey(accountId) {
      return 'pingTreetargetsgetPromise' + accountId;
    }
  }
})();